import LabelWrapper from 'components/Forms/Lib/LabelWrapper/LabelWrapper';
import { InputHTMLAttributes, ReactNode } from 'react';
import { ControllerRenderProps } from 'react-hook-form';
import { ExtractNativePropsFromDefault } from 'typeHelpers/ExtractNativePropsFromDefault';

type NativeProps = ExtractNativePropsFromDefault<
    InputHTMLAttributes<HTMLInputElement>,
    'name',
    'id' | 'disabled' | 'required'
>;

type FilterCheckboxProps = NativeProps & {
    /**
     * Display Label of the HTML checkbox element
     */
    label: ReactNode;
    /**
     * Display count of items. This is an optional prop primary from the parameters filter.
     */
    count?: number;
} & (
        | {
              /**
               * props that are by default included in the fieldRef, but can be used, if a complete fieldRef cannot be provided
               */
              value: unknown;
              /**
               * a ref of the controlled field element used for hooking onto the field events/changes
               */
              fieldRef?: never;
              /**
               * props that are by default included in the fieldRef, but can be used, if a complete fieldRef cannot be provided
               */
              onChange: (...event: any[]) => void;
          }
        | {
              /**
               * props that are by default included in the fieldRef, but can be used, if a complete fieldRef cannot be provided
               */
              value?: never;
              /**
               * a ref of the controlled field element used for hooking onto the field events/changes
               */
              fieldRef: ControllerRenderProps<any, any>;
              /**
               * props that are by default included in the fieldRef, but can be used, if a complete fieldRef cannot be provided
               */
              onChange?: never;
          }
    );

/**
 * An HTML Checkbox element of type checkbox
 */
export const FilterCheckbox: FC<FilterCheckboxProps> = ({
    id,
    name,
    label,
    count,
    required,
    disabled,
    fieldRef,
    onChange,
    value,
}) => {
    return (
        <LabelWrapper
            checked={fieldRef ? fieldRef.value : value}
            className="inline-flex w-full"
            count={count}
            countElement={<span className="ml-auto inline-block pl-2 text-small text-grayDark">&nbsp;{count}</span>}
            htmlFor={id === undefined ? name + 'checkbox-id' : id}
            inputType="checkbox"
            label={label}
        >
            <input
                disabled={disabled}
                id={id === undefined ? name + 'checkbox-id' : id}
                required={required}
                {...(fieldRef ?? {})}
                checked={fieldRef ? fieldRef.value : value}
                className="peer sr-only"
                type="checkbox"
                onChange={fieldRef ? fieldRef.onChange : onChange}
            />
        </LabelWrapper>
    );
};
